"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDJSONWriter = void 0;
var TDJSONWriterOption_1 = require("./TDJSONWriterOption");
var TDNode_1 = require("../TDNode");
var StringBuilder_1 = require("../core/StringBuilder");
var StringUtil_1 = require("../core/StringUtil");
var LangUtil_1 = require("../core/LangUtil");
var NON_STRING = TDJSONWriterOption_1.TextType.NON_STRING;
var STRING = TDJSONWriterOption_1.TextType.STRING;
var KEY = TDJSONWriterOption_1.TextType.KEY;
var OPERATOR = TDJSONWriterOption_1.TextType.OPERATOR;
var TDJSONWriter = /** @class */ (function () {
    function TDJSONWriter() {
    }
    TDJSONWriter.get = function () {
        return TDJSONWriter.instance;
    };
    TDJSONWriter.writeAsString = function (node, opt) {
        if (opt === void 0) { opt = {}; }
        return TDJSONWriter.get().writeAsString(node, opt);
    };
    TDJSONWriter.write = function (out, node, opt, indentStr) {
        if (opt === void 0) { opt = {}; }
        if (indentStr === void 0) { indentStr = ''; }
        return TDJSONWriter.get().write(out, node, opt, (indentStr = ''));
    };
    TDJSONWriter.prototype.writeAsString = function (node, opt) {
        if (opt === void 0) { opt = {}; }
        var out = new StringBuilder_1.StringBuilder();
        this.write(out, node, opt);
        return out.toString();
    };
    TDJSONWriter.prototype.write = function (out, node, option, indentStr) {
        if (option === void 0) { option = {}; }
        if (indentStr === void 0) { indentStr = ''; }
        var opt = option instanceof TDJSONWriterOption_1.TDJSONWriterOption ? option : LangUtil_1.LangUtil.mergeDeep(new TDJSONWriterOption_1.TDJSONWriterOption(), option);
        if (!node)
            return out.append(opt.deco("null", NON_STRING));
        var childIndentStr = '';
        if (opt.hasIndent())
            childIndentStr = indentStr + opt.indentStr;
        switch (node.type) {
            case TDNode_1.TDNodeType.MAP:
                return this.writeMap(out, node, opt, indentStr, childIndentStr);
            case TDNode_1.TDNodeType.ARRAY:
                return this.writeArray(out, node, opt, indentStr, childIndentStr);
            default:
                return this.writeSimple(out, node, opt);
        }
    };
    TDJSONWriter.prototype.writeMap = function (out, node, opt, indentStr, childIndentStr) {
        if (opt.useTypeWrapper) {
            var type = node.getChildValue(opt.KEY_TYPE);
            if (type != null)
                out.append(opt.deco(type, TDJSONWriterOption_1.TextType.TYPE));
        }
        out.append(opt.deco(opt.deliminatorObjectStart.substring(0, 1), OPERATOR));
        if (node.children != null) {
            for (var i = 0; i < node.getChildrenSize(); i++) {
                var cn = opt.applyFilters(node.children[i]);
                if (cn == null || (opt.useTypeWrapper && cn.key === opt.KEY_TYPE))
                    continue;
                if (opt.hasIndent()) {
                    out.append('\n');
                    out.append(childIndentStr);
                }
                // Quote the key in case it's not valid java identifier so that it can be parsed back in Javascript
                this.writeQuotedString(out, cn.key, opt, KEY, !StringUtil_1.StringUtil.isJavaIdentifier(cn.key) || opt.alwaysQuoteKey);
                out.append(opt.deco(opt.deliminatorKey, OPERATOR));
                this.write(out, cn, opt, childIndentStr);
                if (i < node.getChildrenSize() - 1)
                    // No need "," for last entry
                    out.append(opt.deco(opt.deliminatorValue, OPERATOR));
            }
            if (opt.hasIndent() && node.hasChildren()) {
                out.append('\n');
                out.append(indentStr);
            }
        }
        return out.append(opt.deco(opt.deliminatorObjectEnd.substring(0, 1), OPERATOR));
    };
    TDJSONWriter.prototype.writeArray = function (out, node, opt, indentStr, childIndentStr) {
        out.append(opt.deco(opt.deliminatorArrayStart.substring(0, 1), OPERATOR));
        if (node.children != null) {
            for (var i = 0; i < node.getChildrenSize(); i++) {
                var cn = node.children[i];
                if (opt.hasIndent()) {
                    out.append('\n');
                    out.append(childIndentStr);
                }
                this.write(out, cn, opt, childIndentStr);
                if (i < node.getChildrenSize() - 1)
                    // No need "," for last entry
                    out.append(opt.deco(opt.deliminatorValue, OPERATOR));
            }
            if (opt.hasIndent() && node.children.length > 0) {
                out.append('\n');
                out.append(indentStr);
            }
        }
        return out.append(opt.deco(opt.deliminatorArrayEnd.substring(0, 1), OPERATOR));
    };
    TDJSONWriter.prototype.writeSimple = function (out, node, opt) {
        var value = node.value;
        return typeof value === 'string'
            ? this.writeQuotedString(out, value, opt, STRING, opt.alwaysQuoteValue)
            : out.append(opt.deco("" + value, NON_STRING));
    };
    TDJSONWriter.prototype.writeQuotedString = function (out, str, opt, type, alwaysQuote) {
        var quoteChar = this.determineQuoteChar(str, opt, alwaysQuote);
        return quoteChar === '' ? out.append(opt.deco(str, type)) : out.append(quoteChar)
            .append(opt.deco(StringUtil_1.StringUtil.cEscape(str, quoteChar), type))
            .append(quoteChar);
    };
    /** return '' indicate quote is not necessary */
    TDJSONWriter.prototype.determineQuoteChar = function (str, opt, alwaysQuote) {
        var needQuote = alwaysQuote || StringUtil_1.StringUtil.indexOfAnyChar(str, opt._quoteNeededChars) >= 0;
        if (!needQuote)
            return '';
        if (opt.quoteChars.length === 1)
            return opt.quoteChars.charAt(0);
        // Determine which quote char to use
        var counts = new Array(opt.quoteChars.length);
        for (var _i = 0, str_1 = str; _i < str_1.length; _i++) {
            var ch = str_1[_i];
            var idx = opt.quoteChars.indexOf(ch);
            if (idx >= 0)
                counts[idx]++;
        }
        var minIdx = 0; // default to first quote char
        for (var i = 1; i < counts.length; i++)
            if (counts[i] < counts[minIdx])
                minIdx = i;
        return opt.quoteChars.charAt(minIdx);
    };
    TDJSONWriter.instance = new TDJSONWriter();
    return TDJSONWriter;
}());
exports.TDJSONWriter = TDJSONWriter;
//# sourceMappingURL=TDJSONWriter.js.map